import { render, staticRenderFns } from "./NuevaMuestra.vue?vue&type=template&id=6a04ce4a&"
import script from "./NuevaMuestra.vue?vue&type=script&lang=js&"
export * from "./NuevaMuestra.vue?vue&type=script&lang=js&"
import style0 from "./NuevaMuestra.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports